export const STORE_SUBCOLUMNS = ["一乐录音棚", "太乐纪旗舰店", "太乐纪B棚"] as const;

export type StoreSubcolumn = typeof STORE_SUBCOLUMNS[number];
// Per-browser view preference: the venues a given day (YYYY-MM-DD) was expanded to show.
export type DayLocationPrefs = Record<string, StoreSubcolumn[]>;
// One scheduled card as drawn on a day. Times are epoch milliseconds and may be NaN for an unreadable card.
export type LocationSpan = { store: string; start: number; end: number };

export function scheduledStores(spans: readonly LocationSpan[]): StoreSubcolumn[] {
  return STORE_SUBCOLUMNS.filter((name) => spans.some((span) => span.store === name));
}

// True when two venues have events whose times actually overlap. Back-to-back
// events (one ends exactly when the next starts) are not simultaneous.
export function hasSimultaneousLocations(spans: readonly LocationSpan[]) {
  const known = spans
    .filter((span) => STORE_SUBCOLUMNS.some((name) => name === span.store) && Number.isFinite(span.start) && Number.isFinite(span.end) && span.end > span.start)
    .sort((first, second) => first.start - second.start);
  return known.some((span, index) => known.slice(index + 1).some((other) => other.start < span.end && other.store !== span.store));
}

// Venue columns a day is drawn with. An empty list means one merged column.
// Automatic rule: a single venue keeps its one labelled column; several venues
// only split into columns when their events overlap in time. An expanded day
// shows the chosen venues plus every venue that has events, so a scheduled
// event can never be hidden by unticking its venue.
export function displayedStores(spans: readonly LocationSpan[], chosen?: readonly StoreSubcolumn[]): StoreSubcolumn[] {
  const scheduled = scheduledStores(spans);
  if (chosen?.length) return STORE_SUBCOLUMNS.filter((name) => chosen.includes(name) || scheduled.includes(name));
  return scheduled.length <= 1 || hasSimultaneousLocations(spans) ? scheduled : [];
}
